import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { listMarketingTeamAll, reSendInvitationMail, changeStatusMarketingTeam } from "../../../../Context/api";
import axios from "axios";
import { commonMessage, statusCodes } from "../../../../Constants/generalConfig";
import { toast } from "react-toastify";



const UseTeamList = () => {
    const [spinner, setSpinner] = useState(false)
    const [status, setStatus] = useState('true')
    const [marketingTeam, setMarketingTeam] = useState('')
    const [listData, setListData] = useState([]);
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const [page, setPage] = useState(1)
    const [count, setCount] = useState('')
    const PER_PAGE = 10
    const navigate = useNavigate()

    useEffect(() => {
        list()
    }, [page, status])

    const list = () => {
        setSpinner(true)
        const data = {
            page: page,
            count: PER_PAGE,
            createdbyId: adminData?.userId,
            isActive: status == 'true'
        }
        axios.post(listMarketingTeamAll(), { ...data },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setListData(resp.data.data);
                setSpinner(false)
                setCount(resp.data.totalCount);
            }
            else {
                setListData([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })

    };
    const invitationReSend = () => {
        const data = {
            email: marketingTeam?.email,
            marketingTeamId: marketingTeam?.marketingTeamId
        }
        // console.log(data, 'llllll')
        setSpinner(true)
        axios.post(reSendInvitationMail(), data, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setSpinner(false)
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)
            }
        }).catch(() => {
            toast.error(commonMessage.networkError)
            setSpinner(false)
        })
    }
    const statusChange = (item) => {
        setSpinner(true)
        axios.post(changeStatusMarketingTeam(), { teamId: item.marketingTeamId, isActive: !item.isActive }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                list()
                setSpinner(false)
            }

            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
    }
    return {
        page,
        count,
        status,
        spinner,
        PER_PAGE,
        listData,
        setPage,
        navigate,
        setStatus,
        setMarketingTeam,
        invitationReSend,
        statusChange,
    }
}

export default UseTeamList